import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  filterObj: {
    loc: "",
    dateFrom: new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate() - 10
    ),
    dateTo: new Date(),
    statusVal: "ENTER",
    DocNo: "",
  },

  PickingHead: {
    VocTyp: "",
    VocTypName: "",
    VocNo: 0,
    PostDate: new Date(),
    FromDate: new Date(),
    ToDate: new Date(),
    TransactionTypeCd: "",
    TransactionType: "",
    ClusterCd: "",
    Cluster: "",
    LoadingBayCd: "",
    LoadingBay: "",
    TypeCd: "",
    Type: "",
    Loc: "",
    LocName: "",
    DocStatus: "",
    Status: "",
  },
};

const SlicePicking = createSlice({
  name: "Picking",
  initialState: { value: initialState },

  reducers: {
    FilterObj_Set: (state, action) => {
      state.value.filterObj = {
        ...state.value.filterObj,
        ...action.payload,
      };
    },
    PickingHead_Set: (state, action) => {
      state.value.PickingHead = action.payload.PickingHead;
    },
    PickingHead_Status_Set: (state, action) => {
      state.value.PickingHead.Status = action.payload.Status;
    },

    Picking_Init: (state) => {
      state.value = initialState;
    },
  },
});

export const {
  FilterObj_Set,
  PickingHead_Set,
  Picking_Init,
  PickingData_Set,
  PickingHead_Status_Set,
} = SlicePicking.actions;
export default SlicePicking.reducer;
